import { NgModule } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { MessageModule } from 'primeng/message';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
    imports: [
        InputTextModule,
        ButtonModule,
        RadioButtonModule,
        TooltipModule,
        MessageModule
    ],
    providers: [
        DialogService
    ],
    exports: [
        InputTextModule,
        ButtonModule,
        RadioButtonModule,
        TooltipModule,
        MessageModule
    ]
})
export class PrimengComponentsModule {

}
